function findFeatureOrGroupById(itemId, array) {
  for (const featureOrGroup of array) {
    if (featureOrGroup.id === itemId) {
      return featureOrGroup;
    }

    if (!featureOrGroup.children) {
      continue;
    }

    const item = findFeatureOrGroupById(itemId, featureOrGroup.children);
    if (item) {
      return item;
    }
  }
}

export function extractFeaturesAndGroups(selectedFeatureIds, allFeaturesAndGroups) {
  const features = [];
  const groups = [];

  for (const id of selectedFeatureIds) {
    const featureOrGroup = findFeatureOrGroupById(id, allFeaturesAndGroups);

    if (!featureOrGroup) {
      continue;
    }

    if (featureOrGroup.children) {
      groups.push(featureOrGroup.id);
    } else {
      features.push(id);
    }
  }

  return { features, groups };
}

export function extractFeaturesAndGroupsWithDetails(selectedFeatureIds, allFeaturesAndGroups) {
  const features = [];
  const groups = [];

  for (const id of selectedFeatureIds) {
    const featureOrGroup = findFeatureOrGroupById(id, allFeaturesAndGroups);

    if (!featureOrGroup) {
      continue;
    }

    if (featureOrGroup.children) {
      groups.push(featureOrGroup);
    } else {
      features.push(featureOrGroup);
    }
  }

  return { features, groups };
}
